import React from 'react';
import { useIntl } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import Block from 'components/structure/Block/Block';
import ImageBlock from 'components/structure/ImageBlock';
import Section from 'components/structure/Section';

function SectionKnowMore() {
  const { formatMessage } = useIntl();
  return (
    <Section
      backgroundColor="white.dark"
      contained
    >
      <ImageBlock
        loading="lazy"
        imageWidth="100%"
        imageHeight="100%"
        backgroundImage="man-holding-two-phones/man-holding-two-phones.jpg"
        alt={formatMessage({ id: 'LENDING.KNOW_MORE.IMG_ALT' })}
        noPadding
      />
      <Block backgroundColor="white" mobileOrder={3}>
        <Typography
          variant="title"
          color="black"
          colorVariant="default"
          gutterBottom={2}
          maxWidth="22rem"
          intlKey="LENDING.KNOW_MORE.TITLE"
        />
        <Typography
          variant="paragraph2"
          gutterBottom={2}
          intlKey="LENDING.KNOW_MORE.DESCRIPTION"
        />
        <Link
          href="https://blog.nubank.com.br/emprestimo-nubank/"
          color="primary"
          intlKey="LENDING.KNOW_MORE.CTA"
          variant="action"
        />
      </Block>
    </Section>
  );
}

export default React.memo(SectionKnowMore);
